import { useQuery } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import type { AdminApi } from '../../api/client.ts';

/** Choose tags of the environment by checkbox (exception and exempt tags, BB-49). */
export function TagChecklist({ environmentId, label, value, onChange, disabled }: { environmentId: string; label: string; value: string[]; onChange: (next: string[]) => void; disabled?: boolean }) {
  const { api } = useRouter().options.context as { api: AdminApi };
  const tags = useQuery({ queryKey: ['tags', environmentId], queryFn: () => api.listTags(environmentId) });
  return (
    <fieldset aria-label={label}>
      <legend>{label}</legend>
      {(tags.data ?? []).length === 0 ? (
        <p className="hint">No tags yet.</p>
      ) : (
        (tags.data ?? []).map((t) => (
          <label key={t.id}>
            <input type="checkbox" disabled={disabled} checked={value.includes(t.id)} onChange={(e) => onChange(e.target.checked ? [...value, t.id] : value.filter((x) => x !== t.id))} /> {t.name}
          </label>
        ))
      )}
    </fieldset>
  );
}
